import { render, staticRenderFns } from "./component-objectives.vue?vue&type=template&id=6f1a634d&scoped=true"
import script from "./component-objectives.ts?vue&type=script&lang=ts&external"
export * from "./component-objectives.ts?vue&type=script&lang=ts&external"
import style0 from "./component-objectives.less?vue&type=style&index=0&id=6f1a634d&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1a634d",
  null
  
)

export default component.exports